import { getNLegOrderbooks } from "../../../Requests/nLegsRequests";
import useRequest from "../../../Hooks/useRequest";
import { useAppSelector } from "../../../App/hooks";
import { useEffect } from "react";
import OrderBookTable from "../../../Tables/Order/OrderBookTable";
import { StepOrderSide } from "../../../Interfaces/stepInterfaces";
import { addSeperatorToInput } from "../../../helper";
import {
  GetBookOrderResponse,
  INLegOrderbooksBody,
  INLegOrderbooksResp,
  IUNLegsItem,
} from "../../../Interfaces/nLegsInterfaces";
import useLiveOrderBooks from "../../../Hooks/useLiveOrderBooks";

interface IProps {
  legCount: number;
  items?: Pick<IUNLegsItem, "instrumentId" | "ratio" | "orderSide">[];
  getBooks?: (
    body: INLegOrderbooksBody,
    signal?: AbortSignal,
  ) => Promise<INLegOrderbooksResp>;
}
export const InstrumentOrderbook = ({
  legCount,
  items,
  getBooks = getNLegOrderbooks,
}: IProps) => {
  const orderBookRequest = useRequest(
    (signal) =>
      getBooks(
        {
          count: items?.length || 0,
          insIds:
            items && items.length
              ? items.map((i) => {
                  if (i?.instrumentId)
                    return {
                      insId: i?.instrumentId,
                      ratio: i?.ratio,
                      side: i?.orderSide,
                    };
                  return null as any;
                })
              : [],
        },
        signal,
      ),

    (e) => {},
  );
  const liveOrderBooks = useLiveOrderBooks({
    enabled: true,
    instrumentIds: items?.map((item) => item?.instrumentId) || [],
  });

  useEffect(() => {
    if (items?.every((i) => !i?.instrumentId)) return;
    orderBookRequest.fetchData();
    const interval = setInterval(() => {
      orderBookRequest.fetchData();
    }, 10000);
    return () => clearInterval(interval);
  }, [
    getBooks,
    ...(items?.map((i) => (i ? i?.instrumentId : i)) || []),
    ...(items?.map((i) => (i ? i?.ratio : i)) || []),
    ...(items?.map((i) => (i ? i?.orderSide : i)) || []),
  ]);

  const getOrderbookValues = (
    values?: GetBookOrderResponse[],
  ): GetBookOrderResponse[] => {
    if (!values || !values.length) return new Array(legCount).fill(null as any);

    if (values.length < legCount) {
      const res: GetBookOrderResponse[] = [...values];
      for (let index = 0; index < legCount - values.length; index++) {
        res.push(null as any);
      }
      return res;
    }
    return values;
  };

  return (
    <div className="flex flex-col justify-start items-center gap-3 min-h-[225px] mt-7">
      <div className="flex flex-row justify-start items-center">
        {getOrderbookValues(orderBookRequest?.response?.orderBooks)?.map(
          (resp) => (
            <div className="mx-0.5">
              <OrderBookTable
                tableInfo={liveOrderBooks.resolveOrderBook(resp?.fullOrderBook)}
              />
            </div>
          ),
        )}
      </div>
      <div className="flex flex-row justify-start items-center gap-5">
        <div className="">بهای تمام شده:</div>

        {orderBookRequest?.response?.totalPrices?.map((totalPrice, tI) => (
          <div className="flex flex-row justify-start items-center">
            {totalPrice?.ratios?.map((r, i) => (
              <>
                <div
                  className={`${
                    r.orderSide === StepOrderSide.Buy
                      ? "text-green-700"
                      : r.orderSide === StepOrderSide.Sell
                        ? "text-red-700"
                        : "text-gray-600"
                  }`}
                >
                  {r.ratio}
                </div>
                {totalPrice.ratios.length !== i + 1 ? (
                  <>-</>
                ) : (
                  <div
                    className={`mr-5 ltr ${
                      orderBookRequest?.response?.totalPrices.length !== tI + 1
                        ? "border-l-[1px] border-gray-600 pl-5"
                        : ""
                    }`}
                  >
                    {addSeperatorToInput(totalPrice.price, "priceWithDecimal")}
                  </div>
                )}
              </>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const Orderbook = ({ legCount }: Pick<IProps, "legCount">) => {
  const items = useAppSelector(
    (store) => store.nLegs.addOrderFormValues?.uNLegsItems,
  );
  return <InstrumentOrderbook legCount={legCount} items={items} />;
};

export default Orderbook;
